/*eslint-disable*/
import ProductInCart from '../../entities/ProductInCart';

export default {
  ADD_TO_CART(state, { product }) {
    const record = state.added.find((p) => p.id === product.id);
    if (!record) {
      state.added.push(new ProductInCart({
        id: product.id,
        codeSupplier: product.codeSupplier,
        name: product.name,
        packaging: product.packaging,
        unit: product.unit,
        uc: product.uc,
        supplier: product.supplier,
        price: product.price,
        ean: product.ean,
        quantity: 1,
        conditionning: product.conditionning,
      }));
    } else {
      record.quantity++;
    }
  },

  RMV_ONE_FROM_CART(state, { product }) {
    const record = state.added.find((p) => p.id === product.id);

    if (!record) {
      return;
    }

    if (record.quantity === 1) {
      const index = state.added.indexOf(record);
      state.added.splice(index, 1);
    } else {
      record.quantity--;
    }
  },

  RMV_ONE_PRODUCT_FROM_CART(state, { product }) {
    const record = state.added.find(p => p.id === product.id);
    if (!record) {
      return;
    }
    const index = state.added.indexOf(record);
    state.added.splice(index, 1);
  },

  CLEAR_CART(state) {
    state.added = [];
  },

  RMV_ONE_SUPPLIER_FROM_CART(state, { supplier }) {
    state.added =_.remove(state.added, (item) => {
      return item.supplier !== supplier;
    });
  },

  ADD_GIVEN_QUANTITY(state, { quantityAdded, product }) {
    const record = state.added.find(p => p.id === product.id);
    if (!record) {
      state.added.push(new ProductInCart({
        id: product.id,
        codeSupplier: product.codeSupplier,
        name: product.name,
        packaging: product.packaging,
        unit: product.unit,
        uc: product.uc,
        supplier: product.supplier,
        price: product.price,
        ean: product.ean,
        quantity: quantityAdded,
        conditionning: product.conditionning,
      }));
    } else if (quantityAdded === 0) {
      const index = state.added.indexOf(record);
      state.added.splice(index, 1);
    } else {
      record.quantity = quantityAdded;
    }
  },
};
